/** Angular */
import { Injectable } from '@angular/core';
/** Rxjs */
import { Observable } from 'rxjs';
/** Models */
import { DsCompanyLotModel } from '../models/ds-company-lot.model';
/** Services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
/** Interfaces */
import { DsCompanyLotInterface } from '../interfaces/ds-company-lot.interface';
/** Sixense */
import { BydModel } from '@sixense/byd-core-service';
/** Functions */
import { BydGenerateParams } from '../../../functions/byd-generate-params.function';
import { PageModel } from '../../../shared/models/page.model';

@Injectable({
  providedIn: 'root',
})
export class DsCompanyLotService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * The endpoint base path.
   */
  private basePath = '/dscompany/v1/projects/';

  /**
   * Get all lots paginated.
   *
   * @param projectId id of the project.
   * @param pageLot PageModel that contains elementPerPage & pageIndex.
   * @param column column to get
   * @param search Name to search
   * @returns Observable type `<BydModel<DsCompanyLotModel[]>>`
   */
  public getLots(
    projectId: number,
    pageLot: PageModel,
    column = '',
    search = ''
  ): Observable<BydModel<DsCompanyLotModel>> {
    this.path = `${this.basePath}${projectId}/lots`;
    const headers = this.bydRhsHeadersService.setHeadersWithPagination(pageLot.elementsPerPage, pageLot.pageIndex);
    const params = BydGenerateParams({
      column,
      search,
    });
    return this.getModels({ headers, params });
  }

  /**
   * Create DsCompanyLotModel instance.
   *
   *
   * @param jsonObject json flat model
   * @returns new instances of DsCompanyLotModel.
   */
  public createNewInstance(jsonObject: DsCompanyLotInterface): DsCompanyLotModel {
    return new DsCompanyLotModel(jsonObject);
  }
}
